const Colors = {
    purple: '#8800FF',
    purpleLight: '#B982FB',
    purpleLighter: '#ECE0F7',
    purpleLightest: '#F5EBFF',
    purpleDark: '#2C2135',
    purpleTransparent: 'rgba(136, 0, 255, 0.16)',
    purpleTransparent2: 'rgba(136, 0, 255, 0.08)',

    blue: '#00A3FF',

    red: '#FF3D3D',
    redLight: '#FFD6D6',
    redTransparent: 'rgba(255, 61, 61, 0.16)',

    green: '#07C806',
    greenLight: '#EBFBEB',
    greenTransparent: 'rgba(7, 200, 6, 0.16)',

    yellow: '#E4900D',
    yellowLight: '#FBEDD8',
    yellowTransparent: 'rgba(228, 144, 13, 0.16)',

    white: 'white', // for text
    black: 'black', // for cards

    grey: '#B2B2B2', // for disabled states
    grey2: '#D5D1D6', // for tiny mce editor
    greyLight: '#EDECF2', // for dividers
    // greyLighter: '#F5F3F6', // for screen backgrounds
    greyLighter: '#F0EEF1', // for screen backgrounds
    greyDark: '#707070', // for text
    greyTransparent: 'rgba(178, 178, 178, 0.16)',
    greyNavbar: '#9ca3af',

    gold: '#F5BA23',
    goldTransparent: 'rgba(245, 186, 35, 0.16)',

    divider: '#EDECF2',
    textColor: 'black',

    yellowBackground: "rgba(255, 185, 92, 0.18)",
    purpleBackground: "rgba(136, 0, 255, 0.24)",
    yellowLabel: "#D18827",

    gradientInstagram: "linear-gradient(135deg, rgba(193, 53, 132, 0.9), rgba(225, 48, 108, 0.6))",
    gradientTikTok: "linear-gradient(135deg, rgba(105, 201, 208, 0.9), rgba(238, 29, 82, 0.6))",
    gradientPresave: "linear-gradient(135deg, rgba(138, 43, 226, 0.9), rgba(106, 13, 173, 0.6))",
    gradientYouTube: "linear-gradient(135deg, rgba(255, 0, 0, 0.7), rgba(208, 0, 0, 0.6))",
    gradientWebsite: "linear-gradient(135deg, rgba(29, 185, 84, 0.9), rgba(26, 156, 69, 0.6))",

    campaignOrange: '#FFEDDB',
    campaignPurple: '#F1E0FF',
    campaignGreen: '#D7F6D7',
    campaignBlue: '#DBFDFC',
    campaignRed: '#FFE0E0',
    campaignInstagram: 'radial-gradient(122.91% 144.58% at 1.82% 90.84%, rgba(254, 213, 118, 0.24) 0%, rgba(244, 113, 51, 0.24) 26.34%, rgba(188, 48, 129, 0.24) 60.91%, rgba(76, 99, 210, 0.24) 100%)',
    campaignTikTok: 'linear-gradient(315deg, rgba(255, 0, 79, 0.30) 0%, rgba(0, 242, 234, 0.30) 100%)',

    // Streaming Platforms
    amazonMusic: '#FFF5E6',
    anghami: '#f8e6ff',
    appleMusic: '#e8e8e8',
    audiomack: '#FFF5E6',
    deezer: '#edecf2',
    link: '#0066CC',
    napster: '#C2C2C2',
    pandora: '#00A0EE',
    shazam: '#0088FF',
    soundcloud: '#ffdfc4',
    spotify: '#dbf9e6',
    tidal: '#cff4f4',
    yandex: '#FFCC00',

    // Social Platforms
    instagram: '#ffdee7',
    tiktok: '#c7c7c8',
    facebook: '#e2effe',
    twitter: '#dcdcdc',
    x: '#dcdcdc',
    youtube: '#ffe0e0',
    linkedin: '#cfeaf7',
    email: '#ECE0F7',

    DARK_SUCCESS: '#07c80629',
    DARK_WARNING: '#E4900D29',
    GREEN_COLOR: '#00892d',
    GREEN_COLOR_ON_GREEN: '#00892d4f',
    DARK_BLUE_PAPER_CONTAINER: '#1977f314',
    textColorWhite: 'white',
    DARK_DIVIDER_LINE: '#0000001F',
    PAPER_CONTAINER: 'white',
    VIEW_ONLY_BACKGROUND: '#1977f350', // Brighter blue background (increased opacity from 14 to 29)
    PAPER_DARK_CONTAINER: 'black',
    PAPER_LIGHT_CONTAINER: '#FFFFFFCB',
    PAPER_ERROR_CONTAINER: '#FF000028',
    PAPER_WARNING_CONTAINER: '#E4900D28',
    PAPER_BACKGROUND_CONTAINER: '#F5F3F6',
    PAPER_DIVIDER_CONTAINER: '#EDECF2',
    PAPER_DIVIDER_CONTAINER_DARK: '#D9D9D9',
    PAPER_LIGHT_GRAY_CONTAINER: '#E9E9E9',
    PAPER_ACCENT_CONTAINER: '#8800FF14',
    PAPER_ACCENT_CONTAINER_ON_DARK: '#B982FB63',
    PAPER_SUCCESS_CONTAINER: '#EBFBEB',
    VIDEO_BUTTON_CONTAINER: '#00000014',
    LIGHT_VIDEO_HOVER_LAYOUT: '#0000007A',
    DARK_VIDEO_HOVER_LAYOUT: '#000000B8',
    PAPER_DIVIDER_CONTAINER_LIGHT: '#EDECF214',
    GRADIENT: 'linear-gradient(166deg, #80F 0%, #F680C5 100%)',
    BACKGROUND_EMPTY_STATE: '#F0F0EF',
    DARK_GRAY: '#393939',
    BACKGROUND_CHART_BILLING: '#E4900D14',
    GRID_CHART_BILLING: '#7a7a7a80',
    GREEN_COLOR_LIGHT: '#1ED7601F',
    BACKGROUND_TIKTOK_ICON: '#19191929',
    BACKGROUND_YOUTUBE_ICON: '#ff000029',
    GRADIENT_INSTAGRAM: 'radial-gradient(144.41% 122.74% at 1.81% 90.83%, rgba(254, 213, 118, 0.16) 0%, rgba(244, 113, 51, 0.16) 26.34%, rgba(188, 48, 129, 0.16) 60.91%, rgba(76, 99, 210, 0.16) 100%)',
    ORANGE_BACKGROUND: 'rgba(228, 144, 13, 0.16)',

    orangeAnnotation: '#F47133',

    BORDER_COLOR: '#E5E7B',
}

export default Colors